/**
 * Messaging System Constants
 * Centralized configuration for the messaging feature
 */

// Message constraints
export const MESSAGE_MAX_LENGTH = 5000;
export const MESSAGE_MIN_LENGTH = 1;

// Timing constants (in milliseconds)
export const SUCCESS_MESSAGE_DURATION = 3000;
export const GAP_MESSAGE_REFETCH_DELAY = 500;
export const SNACKBAR_AUTO_HIDE_DURATION = 3000;

// UI constants
export const MESSAGES_PER_PAGE = 50; // For future pagination

// GuestRequest statuses that allow messaging
export const MESSAGEABLE_STATUSES = ['accepted', 'pending_confirmation', 'confirmed'] as const;
export type MessageableStatus = typeof MESSAGEABLE_STATUSES[number];

// Error messages
export const ERROR_MESSAGES = {
  MESSAGE_EMPTY: 'Message cannot be empty',
  MESSAGE_TOO_LONG: `Message too long (max ${MESSAGE_MAX_LENGTH} characters)`,
  NOT_AUTHORIZED_SEND: 'Not authorized to send messages to this conversation',
  NOT_AUTHORIZED_ARCHIVE: 'Not authorized to archive this conversation',
  INVALID_RECEIVER: 'Invalid receiver',
  LOAD_FAILED: 'Failed to load conversations',
  SEND_FAILED: 'Failed to send message',
  ARCHIVE_FAILED: 'Failed to archive conversation',
  CONVERSATION_LOAD_FAILED: 'Failed to load conversation',
} as const;

// Success messages
export const SUCCESS_MESSAGES = {
  MESSAGE_SENT: 'Message sent successfully',
  CONVERSATION_ARCHIVED: 'Conversation archived',
} as const;

// Logging prefixes (for easier grep/filtering)
export const LOG_PREFIX = {
  SEND: '📤 [SEND]',
  RECEIVE: '📥 [RECEIVE]',
  ARCHIVE: '📥 [ARCHIVE]',
  AUTH: '🔒 [AUTH]',
  SUBSCRIPTION: '🔔 [SUB]',
  ERROR: '❌ [ERROR]',
  SUCCESS: '✅ [SUCCESS]',
  WARNING: '⚠️ [WARN]',
} as const;

// Environment-based logging
export const isDebugMode = process.env.NODE_ENV === 'development';

export const debugLog = (prefix: string, message: string, data?: any) => {
  if (isDebugMode) {
    console.log(`${prefix} ${message}`, data ?? '');
  }
};
